<script setup>
import {defineProps, defineEmits} from "vue";

defineProps({
    show: Boolean,
    loading: Boolean,
    disabled: Boolean,
    error: Boolean,
    block: Boolean,
})

const emit = defineEmits(["press"]);

function press() {
    emit('press');
}
</script>

<template>
    <w-btn
        color="teal"
        :loading="loading"
        :block="block"
        :text="$t('common.export')"
        icon="mdi-export"
        @press="press"
    />
</template>

<style scoped>

</style>